<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [style]="{ width: '46rem', maxWidth: '94vw' }"
  [header]="
    (isEdit
      ? 'WORK_ENVIRONMENT_SURVEY.SURVEYS.EDIT'
      : 'WORK_ENVIRONMENT_SURVEY.SURVEYS.NEW'
    ) | translate
  "
  (onHide)="close()"
>
  <!-- Steps -->
  <ol class="wizard-steps">
    <li
      class="wizard-step"
      *ngFor="let step of steps; let index = index"
      [class.active]="index === stepIndex"
      [class.done]="index < stepIndex"
    >
      <span class="wizard-step__number">{{ index + 1 }}</span>
      <span class="wizard-step__label">{{
        "WORK_ENVIRONMENT_SURVEY.WIZARD.STEP_" + step | translate
      }}</span>
    </li>
  </ol>

  <div class="loading-state" *ngIf="isLoading">
    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    <span translate>WORK_ENVIRONMENT_SURVEY.LOADING</span>
  </div>

  <div class="wizard-body" *ngIf="!isLoading">
    <!-- Step 1: details -->
    <div class="wizard-pane" *ngIf="stepIndex === 0">
      <div class="form-group">
        <label>
          <span translate>WORK_ENVIRONMENT_SURVEY.WIZARD.SURVEY_TITLE</span>
          <span class="required-indicator">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="title"
          [placeholder]="'WORK_ENVIRONMENT_SURVEY.WIZARD.SURVEY_TITLE_PLACEHOLDER' | translate"
        />
        <small
          class="validation-message"
          *ngIf="detailsTouched && !title.trim()"
        >
          * {{ "REQUIRED" | translate }}
        </small>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>
            <span translate>START_DATE</span>
            <span class="required-indicator">*</span>
          </label>
          <p-datepicker
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showClear]="true"
            [style]="{ width: '100%' }"
            [inputStyle]="{ width: '100%' }"
            [(ngModel)]="startDate"
          ></p-datepicker>
          <small
            class="validation-message"
            *ngIf="detailsTouched && !startDate"
          >
            * {{ "REQUIRED" | translate }}
          </small>
        </div>

        <div class="form-group">
          <label>
            <span translate>END_DATE</span>
            <span class="required-indicator">*</span>
          </label>
          <p-datepicker
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showClear]="true"
            [style]="{ width: '100%' }"
            [inputStyle]="{ width: '100%' }"
            [(ngModel)]="endDate"
          ></p-datepicker>
          <small class="validation-message" *ngIf="detailsTouched && !endDate">
            * {{ "REQUIRED" | translate }}
          </small>
          <small class="validation-message" *ngIf="isEndBeforeStart">
            * {{ "UI_NOTIFICATIONS.END_AFTER_START" | translate }}
          </small>
        </div>

        <div class="form-group">
          <label>
            <span translate>WORK_ENVIRONMENT_SURVEY.REMINDER_DATE</span>
            <span class="required-indicator">*</span>
          </label>
          <p-datepicker
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showClear]="true"
            [style]="{ width: '100%' }"
            [inputStyle]="{ width: '100%' }"
            [(ngModel)]="reminderDate"
          ></p-datepicker>
          <small
            class="validation-message"
            *ngIf="detailsTouched && !reminderDate"
          >
            * {{ "REQUIRED" | translate }}
          </small>
        </div>
      </div>
    </div>

    <!-- Step 2: participants -->
    <div class="wizard-pane" *ngIf="stepIndex === 1">
      <p class="wizard-pane__hint" translate>WORK_ENVIRONMENT_SURVEY.WIZARD.PARTICIPANTS_HINT</p>

      <p-table
        [value]="participants"
        [(selection)]="selectedParticipants"
        dataKey="Id"
        [scrollable]="true"
        scrollHeight="320px"
        styleClass="p-datatable-striped p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem">
              <p-tableHeaderCheckbox />
            </th>
            <th>{{ "NAME" | translate }}</th>
            <th>{{ "EMAIL" | translate }}</th>
            <th>{{ "DEPARTMENT" | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-participant>
          <tr>
            <td>
              <p-tableCheckbox [value]="participant" />
            </td>
            <td>{{ participant.Name }}</td>
            <td>{{ participant.Email }}</td>
            <td>{{ participant.DepartmentName || "—" }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center">
              <span translate>
                WORK_ENVIRONMENT_SURVEY.WIZARD.NO_PARTICIPANTS
              </span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Step 3: summary -->
    <div class="wizard-pane" *ngIf="stepIndex === 2">
      <dl class="summary">
        <dt translate>WORK_ENVIRONMENT_SURVEY.WIZARD.SURVEY_TITLE</dt>
        <dd>{{ title }}</dd>

        <dt translate>START_DATE</dt>
        <dd>{{ startDate | date: "dd.MM.yyyy" }}</dd>

        <dt translate>END_DATE</dt>
        <dd>{{ endDate | date: "dd.MM.yyyy" }}</dd>

        <dt translate>WORK_ENVIRONMENT_SURVEY.REMINDER_DATE</dt>
        <dd>{{ reminderDate | date: "dd.MM.yyyy" }}</dd>

        <dt translate>WORK_ENVIRONMENT_SURVEY.PARTICIPANTS</dt>
        <dd>{{ selectedCount }}</dd>
      </dl>

      <div class="summary-warning" *ngIf="selectedCount === 0">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        <span translate>WORK_ENVIRONMENT_SURVEY.WIZARD.NO_PARTICIPANTS_WARNING</span>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="wizard-footer">
      <button
        type="button"
        class="btn btn-outline-secondary"
        [disabled]="stepIndex === 0 || isSaving"
        (click)="back()"
      >
        <i class="fa fa-angle-left" aria-hidden="true"></i>
        <span translate>BACK</span>
      </button>

      <button
        type="button"
        class="btn btn-success"
        *ngIf="stepIndex < steps.length - 1"
        (click)="next()"
      >
        <span translate>NEXT</span>
        <i class="fa fa-angle-right" aria-hidden="true"></i>
      </button>

      <button
        type="button"
        class="btn btn-success"
        *ngIf="stepIndex === steps.length - 1"
        [disabled]="isSaving"
        (click)="save()"
      >
        <i
          *ngIf="isSaving"
          class="fa fa-spinner fa-spin m-r-1"
          aria-hidden="true"
        ></i>
        <span translate>SAVE</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
